import React from "react";
import SlidingCarousel from "../SlidingCarousel/SlidingCarousel";
import "./FilterString.css" 


// By extending the React.Component class, TextArea inherits functionality from it
class FilterString extends React.Component 
{

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);
    }


    onTopClick = (event) => {
        this.tippyTop.scrollIntoView();
    }

    oneClick = () =>
    {
        this.one.scrollIntoView();
    }
    

    render()
    {
        return(
            <div className="FilterStringMain" className="smooth">
        <h5 ref={node => this.tippyTop = node} className="smooth">Filter String</h5>

        <p>This type of routine will filter a string.  Examples would be to 
            <span onClick={this.oneClick} > remove spaces</span>; another would be to remove "tuples" like aa or bbb.
            Yet another would be to make all words begin with a capital letter.
        </p>

        <p ref={node => this.one = node}  className="smooth">A program to remove spaces from a string follows:
        </p>

         <pre>
            <code>
            <p className="LineNumber"> 1    </p>
            <p className="CodeLine">{"int main(int argc, char* argv()"}</p>
            <br />

            <p className="LineNumber"> 2    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber"> 3        </p>
            <p className="CodeLine">{"// Assume the string is in argv[1]"}</p>
            <br />

            <p className="LineNumber"> 4        </p>
            <p className="CodeLine">{"// Initialize the read and write pointers"}</p>
            <br />

            <p className="LineNumber"> 5        </p>
            <p className="CodeLine">{"char* pReadPtr= argv[1];"}</p>
            <br />

            <p className="LineNumber"> 6        </p>
            <p className="CodeLine">{"char* pWritePtr = argv[1];"}</p>
            <br />

            <p className="LineNumber"> 7        </p>
            <p className="CodeLine">{""}</p>
            <br />

            <p className="LineNumber"> 8        </p>
            <p className="CodeLine">{"while(*pReadPtr)"}</p>
            <br />

            <p className="LineNumber"> 9        </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">10            </p>
            <p className="CodeLine">{"if( *pReadPtr != ' ')"}</p>
            <br />

            <p className="LineNumber">11            </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">12                </p>
            <p className="CodeLine">{"*pWritePtr++ = *pReadPtr++;"}</p>
            <br />

            <p className="LineNumber">13            </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">14            </p>
            <p className="CodeLine">{"else"}</p>
            <br />

            <p className="LineNumber">15            </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">16                </p>
            <p className="CodeLine">{"++pReadPtr;"}</p>
            <br />

            <p className="LineNumber">17            </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">18        </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">18    </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <button onClick={this.onTopClick} className="rightButton">&#x021D1;</button>

               </code>
        </pre>
        <p> The while statement at line eight means that the while loop will continue to run 
            until the read pointer is pointing to 0.  In C, the end of a string is demarked 
            by a termination null, so the while loop will run until the read pointer reaches
            the end of the incoming string.</p>

        <p> The if statement at line ten checks to see if the read pointer is pointing at 
            a space character or not. If it is not, then the character pointed to is copied 
            into the position pointed to by the read pointer.  If it is the space, then the 
            space is NOT copied and only the read pointer is advanced.</p>
        </div>

         );
    }

} // End of class  FilterString

export default FilterString;




// WEBPACK FOOTER //
// ./src/components/CppWhiteBoard/FilterString.js